(function ($) {

    const MEGA_MENU_ITEM_OPENED_CLASS = 'is-opened';
    const MEGA_MENU_ITEM_OPENED_BODY_CLASS = 'mega-menu-opened';
    const MENU_ICON_EXPANDED_CLASS = 'menu-icon--expanded';


    $(document).on('ready', function () {

        $('a[data-depth="1"]').each(function () {
            const $childElementsParent = $(this).find('+ .sub-menu');

            if ($childElementsParent.find('> .menu-item').length > 6) {
                $childElementsParent.addClass('sub-menu--two-cols');
            }
        });


        $('a[data-depth="0"] + .sub-menu').each(function () {
            const $childElements = $(this).find('> li');

            const colsCount = $childElements.length;

            if (colsCount < 3) {
                // to prevent this mega-menu item from stretching to full-container width
                // if there are 2 or fewer sections in current mega-menu item
                $(this).addClass('sub-menu--w-auto');
            }

            if (colsCount === 1) {
                $(this).addClass('sub-menu--one-section');
            }
        });



        // $('a[data-depth="0"]').each(function () {
        //     const $megaMenuItemSectionsParent = $(this).find('+ .sub-menu');
        //     const megaMenuItemSectionsCount = $megaMenuItemSectionsParent.find('> li').length;
        //
        //     if (megaMenuItemSectionsCount < 3) {
        //         $megaMenuItemSectionsParent.addClass('sub-menu--w-auto');
        //     }
        //
        //     if (megaMenuItemSectionsCount === 1) {
        //         $(this).addClass('')
        //     }
        //
        // });



        $('.header-menu > .menu-item-has-children > .menu-link[data-depth="0"]').on('click', function (e) {
            e.preventDefault();
            toggleMegaMenuItem($(this).parent());
        });


        $('#menu-toggle').on('click', function () {
            $(this).toggleClass( MENU_ICON_EXPANDED_CLASS );
            $('#main-menu').toggleClass('header__nav--expanded');
            toggleBodyMenuOpenedClasses( $(this).hasClass( MENU_ICON_EXPANDED_CLASS ) );
        });


        centerNextFrame('[data-depth="0"] + .sub-menu');

    });


    $(window).on('resize', function() {
        centerNextFrame('[data-depth="0"] + .sub-menu');
    })


    // closing opened mega-menu item when user clicked outside of it
    $('body').on('click', function (e) {

        const $el = $(e.target);
        const $targetOpenedMegaMenuItem = $el.closest(`.menu-item.${MEGA_MENU_ITEM_OPENED_CLASS}`);
        const $currentOpenedMegaMenuItem = $(`.menu-item.${MEGA_MENU_ITEM_OPENED_CLASS}`);

        // if some mega-menu item is currently opened
        // and user clicked outside of it ($targetOpenedMegaMenuItem.length === 0)
        if ( $currentOpenedMegaMenuItem.length > 0 && $targetOpenedMegaMenuItem.length === 0 ) {
            toggleMegaMenuItem($currentOpenedMegaMenuItem);
        }

    });



    function toggleMegaMenuItem($menuItem) {
        if ($menuItem && $menuItem.length) {
            $menuItem.siblings().removeClass(MEGA_MENU_ITEM_OPENED_CLASS);

            $menuItem.toggleClass(MEGA_MENU_ITEM_OPENED_CLASS);

            toggleBodyMenuOpenedClasses($menuItem.hasClass( MEGA_MENU_ITEM_OPENED_CLASS ));
        }
    }



    function toggleBodyMenuOpenedClasses(toRemove) {
        if (toRemove) {
            $('html, body').addClass( MEGA_MENU_ITEM_OPENED_BODY_CLASS );
        }
        else {
            $('html, body').removeClass( MEGA_MENU_ITEM_OPENED_BODY_CLASS );
        }
    }




    function centerNextFrame(selector) {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => { // 2 frames = more reliable after class/style changes
                centerClampX(selector, {padding: 16});
            });
        });
    }


    function centerClampX(target, opts = {}) {
        const padding = Number(opts.padding ?? 16);
        const setTransform = Boolean(opts.setTransform ?? false);
        const debug = Boolean(opts.debug ?? false);
        const onlyIfOverflow = Boolean(opts.onlyIfOverflow ?? true);

        let elements = [];
        if (typeof target === "string") {
            elements = Array.from(document.querySelectorAll(target));
        } else if (target instanceof Element) {
            elements = [target];
        } else if (target && typeof target.length === "number") {
            elements = Array.from(target).filter((n) => n instanceof Element);
        }

        if (!elements.length) {
            throw new Error("No elements found for: " + String(target));
        }

        const vw = document.documentElement.clientWidth;
        const centerX = vw / 2;

        return elements.map((el) => {
            el.style.left = '0px';

            const before = el.getBoundingClientRect();

            const alwaysCenter = Boolean(el.closest('.always-centered'));

            // Optionally enforce the transform you rely on
            if (setTransform) {
                const t = getComputedStyle(el).transform;
                // If transform is "none", apply translateX(-50%); otherwise don't overwrite.
                if (t === "none") {
                    el.style.transform = "translateX(-50%)";
                }
            }

            const overflowLeft = padding - before.left;                 // >0 means overflow on left
            const overflowRight = before.right - (vw - padding);        // >0 means overflow on right
            const isOverflowing = overflowLeft > 0 || overflowRight > 0;

            if ((onlyIfOverflow && !alwaysCenter) && !isOverflowing) {
                return { el, changed: false, before, after: before, shiftPx: 0 };
            }

            // Desired rect.left (clamped) after moving:
            // - Ideally center: rect.left = centerX - width/2
            // - But clamp within [padding, vw - padding - width]
            const width = before.width;
            const desiredLeft = centerX - width / 2;

            const minLeft = padding;
            const maxLeft = Math.max(padding, vw - padding - width);

            const clampedLeft = Math.min(Math.max(desiredLeft, minLeft), maxLeft);

            // Shift needed in viewport pixels
            const shiftPx = clampedLeft - before.left;

            // Compute current left in px relative to offsetParent, then add shift.
            // getBoundingClientRect is viewport-based, so we adjust via left px on the element.
            const cs = getComputedStyle(el);
            const currentLeftPx = parseFloat(cs.left) || 0;

            // If left is 'auto', we need a baseline. Use current visual position:
            // set left based on current left (in viewport) + current scrollX if fixed? (fixed ignores scroll).
            // We'll handle both:
            const pos = cs.position;
            const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;

            let baselineLeftPx = currentLeftPx;
            if (cs.left === "auto") {
                // Convert current viewport left into a pixel "left" value.
                // For fixed: viewport coords are fine.
                // For absolute: need to account for offsetParent's rect.
                const parent = el.offsetParent instanceof Element ? el.offsetParent : null;
                const parentRect = parent ? parent.getBoundingClientRect() : { left: 0 };
                baselineLeftPx = (before.left - parentRect.left) + (pos === "absolute" ? 0 : 0);
                el.style.left = `${baselineLeftPx}px`;
                // If element used translateX(-50%) before, baseline may feel odd; but good enough for temp helper.
            }

            el.style.left = `${baselineLeftPx + shiftPx}px`;

            const after = el.getBoundingClientRect();
            const changed = Math.abs(shiftPx) > 0.5;

            if (debug) {
                console.log("centerClampX:", { el, overflowLeft, overflowRight, shiftPx, before, after });
            }

            return { el, changed, before, after, shiftPx };
        });
    }




})(jQuery);